import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { captureAppError } from '../posthog.js';
import {
  DEFAULT_QUERY_GC_TIME_MS,
  STABLE_RESOURCE_STALE_TIME_MS,
  shouldRetryDefaultQuery,
} from './policy.js';

function stringifyKey(key: unknown): string {
  try {
    return JSON.stringify(key);
  } catch {
    return String(key);
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      captureAppError(error, {
        surface: 'react_query',
        step: 'query',
        user_visible_message: error instanceof Error ? error.message : 'Query failed',
        details: {
          query_key: stringifyKey(query.queryKey),
        },
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      captureAppError(error, {
        surface: 'react_query',
        step: 'mutation',
        user_visible_message: error instanceof Error ? error.message : 'Mutation failed',
        details: {
          mutation_key: mutation.options.mutationKey
            ? stringifyKey(mutation.options.mutationKey)
            : undefined,
        },
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: STABLE_RESOURCE_STALE_TIME_MS,
      gcTime: DEFAULT_QUERY_GC_TIME_MS,
      retry: shouldRetryDefaultQuery,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
